export default __webpack_public_path__ + "static/media/16.8671afc7.png";